module.exports = __webpack_public_path__ + "img/白条-C端用户活动界面.21f27ed4.png";